(function () {
  'use strict';

  function initScrollReveal(root) {
    var items = root.querySelectorAll('.scroll-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in-view'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            setTimeout(function () {
              entry.target.classList.add('is-in-view');
            }, (i % 6) * 70);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  function initCatalogDrag(root) {
    var track = root.querySelector('[data-lamp-catalog-track]');
    if (!track) return;

    var DRAG_THRESHOLD = 6;
    var isDown = false;
    var moved = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > DRAG_THRESHOLD) {
        moved = true;
        track.scrollLeft = scrollLeft - delta;
      }
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      track.addEventListener(evt, function () { isDown = false; });
    });

    // Solo bloquea la navegación del link si hubo un arrastre real;
    // un click/tap normal (sin mover) sigue navegando como corresponde.
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function initTilt(root) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cards = root.querySelectorAll('[data-lamp-tilt]');
    cards.forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'translateY(-8px) rotateX(' + (y * -8) + 'deg) rotateY(' + (x * 10) + 'deg)';
      });
      card.addEventListener('pointerleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initParallax(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-parallax]'));
    if (!items.length) return;

    var ticking = false;

    function update() {
      var scrollY = window.scrollY || window.pageYOffset;
      items.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.2;
        var baseTop = el.__lampBaseTop;
        if (baseTop === undefined) {
          baseTop = el.getBoundingClientRect().top + scrollY;
          el.__lampBaseTop = baseTop;
        }
        var offset = (scrollY - baseTop) * speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      items.forEach(function (el) { el.__lampBaseTop = undefined; });
      update();
    });
    update();
  }

  function initHeroVideoClip(root) {
    var video = root.querySelector('[data-lamp-hero-video]');
    if (!video) return;

    var start = parseFloat(video.getAttribute('data-clip-start')) || 0;
    var end = parseFloat(video.getAttribute('data-clip-end')) || 9;

    // No confiamos solo en el atributo autoplay del HTML: en algunos
    // navegadores/contextos no arranca solo aunque esté muteado. Lo
    // forzamos nosotros mismos por código.
    function tryPlay() {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* si el navegador igual lo bloquea, no rompemos nada */
        });
      }
    }
    tryPlay();
    video.addEventListener('loadeddata', tryPlay);
    document.addEventListener(
      'visibilitychange',
      function () {
        if (!document.hidden && video.paused) tryPlay();
      }
    );

    if (end <= start) return;

    // El recorte por URL (#t=start,end) no se respeta de forma
    // confiable en todos los navegadores para videos con loop, así
    // que lo forzamos manualmente: apenas llega al segundo de fin,
    // saltamos de vuelta al de inicio.
    video.addEventListener('timeupdate', function () {
      if (video.currentTime >= end) {
        video.currentTime = start;
      }
    });
    video.addEventListener('loadedmetadata', function () {
      if (video.currentTime < start || video.currentTime > end) {
        video.currentTime = start;
      }
    });
  }

  function initFaqAccordion(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('.lamp-faq__item'));
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-lamp-faq-trigger]');
      var panel = item.querySelector('[data-lamp-faq-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          other.classList.remove('is-open');
          other.querySelector('[data-lamp-faq-trigger]').setAttribute('aria-expanded', 'false');
          other.querySelector('[data-lamp-faq-panel]').style.maxHeight = '';
        });

        if (!wasOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  function initHeroNightfall(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var hero = root.querySelector('.lamp-home-hero');
    if (!hero) return;

    var ticking = false;

    function update() {
      var heroHeight = hero.offsetHeight || 1;
      var progress = (window.scrollY || window.pageYOffset) / heroHeight;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      hero.style.setProperty('--lamp-scroll-progress', progress.toFixed(3));
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', update);
    update();
  }

  function initBackButton(root) {
    var backLink = root.querySelector('[data-lamp-back]');
    if (!backLink) return;

    backLink.addEventListener('click', function (e) {
      var cameFromSameSite = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
      if (cameFromSameSite && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
      // si no hay de dónde volver (llegó por link directo/nueva pestaña),
      // sigue el href normal del link (inicio de la tienda).
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.lamp-home');
    if (!root) return;
    initScrollReveal(root);
    initCatalogDrag(root);
    initTilt(root);
    initParallax(root);
    initHeroVideoClip(root);
    initFaqAccordion(root);
    initHeroNightfall(root);
    initBackButton(root);
  });
})();